module.exports = __webpack_public_path__ + "img/bg-1.b478ec55.jpg";